import Config from "../../config/Config";
import ErrorHandler from "./errorHandler";
const axios = require("axios");

const baseUrlDev = Config.BaseUrlDev;

const bearer = () => {
  return localStorage.getItem("token_redux").replaceAll('"', "");
};

export const getUser = () => {
  let url = baseUrlDev + "katalis/user";
  console.log("bearer", `Bearer ${bearer()}`);
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${bearer()}`,
        },
      })
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        console.log(err);
        ErrorHandler(err);
        reject(err);
      });
  });
};

export const getCards = () => {
  let url =
    baseUrlDev +
    "katalis/card" +
    "?key=&page=0" +
    "&size=10" +
    "&sort=createdTime,desc";
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${bearer()}`,
        },
      })
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        console.log(err);
        ErrorHandler(err);
        reject(err);
      });
  });
};

export const saveUnlimited = (data) => {
  let url = baseUrlDev + "katalis/user";
  return new Promise((resolve, reject) => {
    axios
      .put(url, data, {
        headers: {
          Authorization: `Bearer ${localStorage
            .getItem("token_redux")
            .replaceAll('"', "")}`,
        },
      })
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        ErrorHandler(err);
        reject(err);
      });
  });
};

export const saveCard = (id, data) => {
  let url = baseUrlDev + "katalis/card/" + id;
  return new Promise((resolve, reject) => {
    axios
      .put(url, data, {
        headers: {
          Authorization: `Bearer ${localStorage
            .getItem("token_redux")
            .replaceAll('"', "")}`,
        },
      })
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        ErrorHandler(err);
        reject(err);
      });
  });
};
